<template>
<button
  type="button"
  data-bind="click: action"
  class="btn btn-action btn-lg btn-primary btn-circle light-bottom-shadow"
  v-on:click="onClickActionButton"
>
  <i class="fas" :class="[icon,size]"></i>
</button>
</template>

<script>
export default {
  name: 'ActionButton',
  props: {
    icon: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'fa-md'
    }
  },
  methods: {
    onClickActionButton (e) {
      this.$emit('click', e)
    }
  }
}
</script>

<style scoped>
.btn-action {
  position: absolute;
  right: 16px;
  bottom:-40px;
  z-index: 1000;
}

@media (max-width: 768px) {
  .btn-action {
    right: 0px !important;
    bottom: -40 !important;
    z-index: 1000;
  }
}
</style>
